import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Api from "@/services/api"
    import { User } from "@/services/types"
    import { ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"
    import { useStore } from "vuex"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateUser',
  setup(__props) {

    const store = useStore()
    const user = reactive<User>({
        name: 'insira o nome',
        phone: 820000000,
        password: '',
        role: 'seller'
    })

    const rules = reactive<FormRules<User>>({
        name: [{required: true, message: 'Insira o nome', min: 1}],
        phone: [{required: true, message: 'Insira o número de telefone'}],
        password: [
            {required: true, message: 'Insira uma senha'},
            {min: 6, message: 'Pelo menos 6 caracteres'},
        ],
        location: [{required: true, message: 'Insira o bairo'}]
    })

    const saving = ref<boolean>(false)
    const formRef = ref<FormInstance>()

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        await formEl.validate(async (valid) => {
            if (valid) {
                saving.value = true

                const res = await Api.post('admin/users', user)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Vendedor cadastrado com sucesso'})
                    store.commit('setOpenModal', -1)
                    // router.push('/sellers')
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                saving.value = false
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    disabled: saving.value,
    rules: rules,
    model: user,
    "label-position": "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "Nome",
        prop: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: user.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.name) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Bairo",
        prop: "location"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "text",
            modelValue: user.location,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.location) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Cargo",
        prop: "role"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: user.role,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.role) = $event)),
            placeholder: "Selecione o tipo de conta"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Administrador",
                value: "admin"
              }),
              _createVNode(_component_el_option, {
                label: "Entregador",
                value: "seller"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Numero de telefone",
        prop: "phone"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "number",
            modelValue: user.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.phone) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "Senha de acesso",
        prop: "password"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            type: "password",
            modelValue: user.password,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.password) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        plain: "",
        loading: saving.value,
        size: "large",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (submit(formRef.value)), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Cadastrar " + _toDisplayString({seller: 'Vendedor', admin: 'Administrador'}[user.role ?? 'seller']), 1)
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["disabled", "rules", "model"]))
}
}

})